@if (inquiry()) {
    <h3>{{ 'payroll.kyc-kyb.payroll-setup.business-verification.title' | translate }}</h3>
    <table>
        <tr>
            <th colspan="5">
                <h4>{{ 'payroll.kyc-kyb.payroll-setup.business-verification.signing-officer.title' | translate }}</h4>
            </th>
        </tr>
        <ng-container
            [ngTemplateOutlet]="tableRow"
            [ngTemplateOutletContext]="{ inquiry: signingOfficer(), translationKey: 'signing-officer' }"
        />
        <tr>
            <th colspan="5">
                <h4>{{ 'payroll.kyc-kyb.payroll-setup.business-verification.UBOs.title' | translate }}</h4>
            </th>
        </tr>
        @for (ubo of UBOs(); track ubo.id) {
            <ng-container
                [ngTemplateOutlet]="tableRow"
                [ngTemplateOutletContext]="{ inquiry: ubo, translationKey: 'UBOs' }"
            />
        }
    </table>
} @else {
    <div class="loadable loading"></div>
}

<ng-template #tableRow let-inquiry="inquiry" let-translationKey="translationKey">
    @if (inquiry) {
        <tr>
            <td>{{ inquiry.firstName }}&nbsp;{{ inquiry.lastName }}</td>
            <td>{{ inquiry.email }}</td>
            @if (inquiry.ownership) {
                <td>{{ inquiry.ownership }}%</td>
                <td><app-kyc-kyb-badge [status]="inquiry.status" /></td>
                <td *showIfFlag="'kyb-resend-ubo-invites'">
                    @if (inquiry.status !== 'complete') {
                        @if (sentInvites[inquiry.id]) {
                            <div class="invite-sent">
                                <mat-icon svgIcon="check" />{{
                                    'payroll.kyc-kyb.payroll-setup.business-verification.sent' | translate
                                }}
                            </div>
                        } @else if (sentInvites[inquiry.id] === false) {
                            <div class="loadable loading"></div>
                        } @else {
                            <ui-button type="link" size="no-padding" (click)="resendInvite(inquiry)"
                                ><mat-icon svgIcon="mail" />{{
                                    'payroll.kyc-kyb.payroll-setup.business-verification.' + translationKey + '.resend'
                                        | translate
                                }}</ui-button
                            >
                        }
                    }
                </td>
            } @else {
                <td colspan="3"></td>
            }
        </tr>
    }
</ng-template>
